/**
 * Device detection utilities for responsive design
 */

/**
 * Detect if the current device is mobile
 * @returns true if the device is a mobile device (iPhone, iPad, iPod, or Android)
 */
export function isMobileDevice(): boolean {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

/**
 * Add device-specific class to document root for CSS-based responsive design.
 * Adds 'mobile-device' class on mobile devices, 'desktop-device' on desktop.
 * This enables CSS rules like `.mobile-device .some-element { ... }`
 *
 * Call this early in your app initialization.
 */
export function initDeviceDetection(): void {
  if (isMobileDevice()) {
    document.documentElement.classList.add('mobile-device');
  } else {
    document.documentElement.classList.add('desktop-device');
  }
}
